const getEnvUrl = (val, fallback) => {
  if (!val || val.includes('(')) return fallback;
  return val;
};

export const ENV = {
  API_URL: getEnvUrl(process.env.REACT_APP_API_URL, 'http://localhost:8081/api/v1/web'),
  API_SSO_URL: getEnvUrl(process.env.REACT_APP_SSO_URL, 'http://20.6.9.38:8080'),
  PUBLIC_FRONTEND_URL: getEnvUrl(process.env.REACT_APP_PUBLIC_FRONTEND_URL, 'http://localhost:3000'),
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
  SHOW_MOBILE_UPLOAD_OVERLAY: process.env.REACT_APP_SHOW_MOBILE_UPLOAD_OVERLAY === 'true',
  VERSION: getEnvUrl(process.env.REACT_APP_VERSION, 'v1.0.0'),
};

export default ENV;
